(function () {
    'use strict';

    angular
        .module('huddle')
        .controller('CareerAdvisorsController', CareerAdvisorsController);

    CareerAdvisorsController.$inject = ['HuddleService','ExpoService','$timeout'];

    function CareerAdvisorsController(HuddleService, ExpoService, $timeout) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.getByFilterCsv        = getByFilterCsv;
        vm.deleteCareerAdvisor   = deleteCareerAdvisor;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo() {
            vm.query = {};
            ExpoService.getExposHuddle(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            vm.flag                     = false;
            HuddleService.getByFilterCareerAdvisors(vm.query).then(function(response) {
                console.log(response);
                vm.flag = true;
                vm.users = response.data;
                vm.totalItems = response.total;
                vm.to = response.to;
                vm.itemsPerPage = response.per_page;
                vm.setPage(response.current_page);

            }).catch(function(err) {
            });
        }

        function getByFilterCsv()
        {
            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            HuddleService.getByFilterCareerAdvisorsCsv(vm.query).then(function(response, status, headers, config){
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data);
                anchor.target = '_blank';
                anchor.download = 'report_huddle_career_advisors.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }

        function deleteCareerAdvisor(user)
        {
            alertify
                .confirm('Do you really delete ' + user.name + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['id']  = user.id;
                    HuddleService.deleteCareerAdvisor(vm.query).then(function(response) {
                        vm.users.splice(vm.users.indexOf(user), 1);
                        alertify.notify('Career advisor successfully deleted!', 'success', 3);
                    }).catch(function(err) {
                    });
                })
                .show();

        }
    }

})();